import {
  tryLoadDependencies,
  tryLoadLightDOMStyles,
  WebAwesomeComponent,
} from '../Global/loadDependency'
import { getTemplateNavHeaderStyles } from './NavHeader-Level2.styles'
import {
  ATTRIBUTES,
  CONTENT_WIDTH_VALUES,
  type ContentWidthValue,
} from '../NavHeader/types/NavHeader.type'

const t = document.createElement('template')
t.innerHTML = `
  <header class="ascend-header ascend-header-level2 header-inner" role="banner">
    <nav class="main-nav" role="navigation" aria-label="Main Navigation">
      <slot name="logo"></slot>
      <slot name="utilityNavigation"></slot>
    </nav>
    <div class="mobile-header">
      <slot name="primarySearchContainer"></slot>
      <slot name="mobilecontextualNavigation"></slot> 
    </div>

    <slot name="primaryNavigationMobile"></slot>
    <div class="tab-header">
      <slot name="contextualNavigation"></slot> 
    </div>
  </header>
`
const TemplateNavHeader = t

class NavHeaderLevel2 extends HTMLElement {
  private isUpdating = false

  static get observedAttributes() {
    return [ATTRIBUTES.HEADER_CONTENT_WIDTH]
  }

  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Tree, WebAwesomeComponent.TreeItem])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(TemplateNavHeader.content.cloneNode(true))

    tryLoadLightDOMStyles('NavHeader-Level2.css')
  }

  connectedCallback() {
    console.log('NavigationSiteHeader connectedCallback')

    this.addEventListener('search-state-changed', this.handleSearchStateChange as EventListener)
    this.addEventListener('search-icon-clicked', this.handleSearchIconClick as EventListener)
    
    // Initialize header-content-width attribute
    this.updateContentWidthClass()
  }
  disconnectedCallback() {
    this.removeEventListener('search-state-changed', this.handleSearchStateChange as EventListener)
    this.removeEventListener('search-icon-clicked', this.handleSearchIconClick as EventListener)
  }

  attributeChangedCallback(name: string, oldValue: string | null, newValue: string | null) {
    if (name === ATTRIBUTES.HEADER_CONTENT_WIDTH && oldValue !== newValue) {
      this.updateContentWidthClass()
    }
  }

  private handleSearchStateChange = (event: CustomEvent) => {
    const { visible } = event.detail
    const value = visible.toString()

    this.querySelectorAll('ts-navheader-search-container').forEach((el) =>
      el.setAttribute('search-visible', value),
    )

    // Utility search button
    this.querySelectorAll('ts-navheader-utility-search-button').forEach((el) =>
      el.setAttribute('search-visible', value),
    )

    // Utility search icon (button will auto-sync from this)
    this.querySelectorAll('ts-navheader-utility-search').forEach((el) =>
      el.setAttribute('search-visible', value),
    )
  }
  private handleSearchIconClick = (event: CustomEvent) => {
    console.log('Search icon clicked:', event.detail)
  }

  private updateContentWidthClass() {
    // Prevent infinite loop
    if (this.isUpdating) return
    this.isUpdating = true

    try {
      const contentWidth = this.getAttribute(ATTRIBUTES.HEADER_CONTENT_WIDTH) || CONTENT_WIDTH_VALUES.CONTAINED
      const validValues = Object.values(CONTENT_WIDTH_VALUES)
      const finalValue = validValues.includes(contentWidth as ContentWidthValue)
        ? contentWidth
        : CONTENT_WIDTH_VALUES.CONTAINED
      
      // Log warning if invalid value provided
      if (contentWidth !== finalValue) {
        console.warn(
          `NavHeader-Level2: Invalid header-content-width value "${contentWidth}". Using default "${CONTENT_WIDTH_VALUES.CONTAINED}". Valid values: ${validValues.join(', ')}`
        )
      }
      
      // Normalize to valid value if needed
      if (contentWidth !== finalValue) {
        this.setAttribute(ATTRIBUTES.HEADER_CONTENT_WIDTH, finalValue)
      }
    } finally {
      this.isUpdating = false
    }
  }
}

if (!customElements.get('ts-navheader-level2')) {
  customElements.define('ts-navheader-level2', NavHeaderLevel2)
}

export { NavHeaderLevel2 }